import React, { useContext, useState } from "react"

import { FER } from "src/constants"
import { Box } from "@mui/material"
import Text from "src/components/Text"
import { RewardsBalancesContext } from "src/providers/RewardsBalancesProvider"
import FerroPriceText from "src/components/FerroPriceText"
import { formatUnits } from "ethers/lib/utils"
import PoolSection from "./PoolSection"
import VaultSection from "./VaultSection"
import {
  usePollFerroBoostPoolData,
  usePollUserFerroBoost,
  useUserFerroBoost,
} from "src/state/xFer/hooks"
import { useActiveWeb3React } from "src/hooks"
import { reduce } from "lodash"
import { BIG_ZERO } from "src/constants/bigNumber"
import CustomCard from "src/components/CustomCard"
import Switch from "src/components/Switch"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import { useGetAllBoostReward } from "src/hooks/BoostFarming/useFarmBoostContract"

const Rewards = () => {
  const [tabIndex, setTabIndex] = useState(0)

  const { account } = useActiveWeb3React()
  const { boostData } = useUserFerroBoost()
  const [rewards] = useContext(RewardsBalancesContext)
  const { data: totalBoostedRewards } = useGetAllBoostReward()

  const totalPoolRewards = reduce(
    rewards,
    (prev, curr) => prev.add(curr),
    BIG_ZERO,
  )
  const totalFer = totalPoolRewards
    .add(boostData.pendingFer)
    .add(totalBoostedRewards ?? BIG_ZERO)

  usePollUserFerroBoost(account)
  usePollFerroBoostPoolData()

  return (
    <Box maxWidth="596px" mx="auto" p={2}>
      <Text variant="h2" textAlign="center" mb={3}>
        Rewards
      </Text>
      <CustomCard withGradient variant="darker-gray">
        {!account ? (
          "Connect to a wallet to view your rewards."
        ) : (
          <Box>
            <CustomCard variant="darkest-gray" borderRadius="10px 10px 0 0">
              <CustomCard variant="black50" p={2}>
                <Text size="small">Total Pending Rewards in Protocol</Text>
                <Text bold my={0.5}>{`${FER.symbol} ${formatNumber(
                  formatUnits(totalFer, FER.decimals),
                  2,
                  6,
                )}`}</Text>
                <FerroPriceText amount={totalFer} />
              </CustomCard>
            </CustomCard>
            <CustomCard
              variant="darkest-gray"
              mt={1}
              borderRadius="0 0 10px 10px"
            >
              <Box textAlign="center">
                <Switch
                  tabs={[
                    { label: "POOL", value: 0 },
                    { label: "VAULT", value: 1 },
                  ]}
                  activeValue={tabIndex}
                  onChange={setTabIndex}
                />
              </Box>
              <Box>{tabIndex === 0 ? <PoolSection /> : <VaultSection />}</Box>
            </CustomCard>
          </Box>
        )}
      </CustomCard>
    </Box>
  )
}

export default Rewards
